// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--XxxBs","close":"dd31006766--close--m2ou3","title":"dd31006766--title--dU61K"};